import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined';
import { Box, Typography } from '@mui/material';

import { ReportBtn } from 'components/buttons';
import { Block } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { useSellersVtexContext } from 'pages/logistica/sellers-vetex/contexts';

export function SellersVtexReport() {
    const { filter } = useListagemContext();
    const { sellersVtex } = useSellersVtexContext();

    return (
        <Block>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alinItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TableViewOutlinedIcon color="primary" />

                    <Typography sx={{ ml: 2, mr: 1 }}>RELATÓRIO REFERENTE AOS FILTROS INFORMADOS</Typography>

                    <ChevronRightOutlinedIcon color="primary" />
                </Box>

                <ReportBtn
                    disabled={!sellersVtex.length}
                    requestOptions={{
                        url: '/gestao/seller/exportar/xlsx',
                        sort: [{ property: 'idSeller', direction: 'DESC' }],
                        nested: true,
                        filter,
                    }}
                />
            </Box>
        </Block>
    );
}
